export default "__VITE_ASSET__DwTNCpPr__"